export enum Paths {
  Dashboard = '/',
  PointOfSales = '/point-of-sales',
  Underwear = '/underwear',
  Login = '/login',
  GlowUp = '/glow-up',
}
